// extracted by mini-css-extract-plugin
module.exports = {"link":"RedCollar_link___s5DS"};